// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TimeInfo__wrap--2KzR7"};